import { Constants } from '../common/Constants';
import { msalInstance, ensureMsalInitialized } from './msalProvider';
import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';

export class CustomAppApiAuthProvider {
  public static readonly instance: CustomAppApiAuthProvider =
    new CustomAppApiAuthProvider();

  private constructor() { }

  public async getToken(
    scopes: string[] = [Constants.VITE_APP_API_SCOPES]
  ): Promise<string> {
    if (Constants.IS_WEBCOMPONENT) {
      return this.getTokenFromWebComponent();
    }
    
    // Ensure MSAL is initialized before attempting token acquisition
    await ensureMsalInitialized();
    
    const account = this.getFirstAccount();
    try {
      return await this.acquireTokenSilentOrThrow(scopes, account);
    } catch (error) {
      await this.handleTokenAcquisitionError(error, scopes, account);
      throw new Error('Authentication failed. Please try logging in again.');
    }
  }

  private getTokenFromWebComponent(): string {
    return sessionStorage.getItem(`${Constants.WEB_COMPONENT_AUTH_TOKEN_NAME}`) || '';
  }

  private getFirstAccount() {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      console.error('No accounts found');
      throw new Error(
        'No authentication account available. Please ensure you are logged in.'
      );
    }
    return accounts[0];
  }

  private async acquireTokenSilentOrThrow(scopes: string[], account): Promise<string> {
    const response = await msalInstance.acquireTokenSilent({
      scopes: scopes,
      account: account,
    });
    if (!response.accessToken) {
      console.error('Token is null or empty');
      throw new Error(
        'Failed to obtain access token. Please try signing in again.'
      );
    }
    return response.accessToken;
  }

  private async handleTokenAcquisitionError(error, scopes: string[], account): Promise<void> {
    if (error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError) {
      console.warn('Silent token acquisition failed, interaction required');
      
      // Ensure MSAL is initialized before attempting interactive login
      await ensureMsalInitialized();
      
      if (globalThis.location.origin.includes('kantarmarketplace') || globalThis.location.origin.includes('localhost')) {
        await msalInstance.loginPopup({
          scopes: scopes,
          account: account,
        });
        globalThis.location.reload();
      } else {
        await msalInstance.acquireTokenRedirect({
          scopes: scopes,
          account: account,
        });
        throw new Error('Redirecting to login...');
      }
    }
    console.error('Failed to get access token:', error);
  }
}
